<div class="new-version-text">{{ 'NEW_APP_VERSION_POPUP_TEXT' | translate }}</div>
<warema-button
    class="refresh-browser-btn"
    id="refresh-browser-btn"
    [text]="'REFRESH_BROWSER' | translate"
    (click)="popupResult$.next(true)"
/>
